module.exports = __webpack_public_path__ + "img/19.4-gallery.0ffc37b3.jpg";